
<!-- Always show header (banner with sign out) -->
<app-header></app-header>

@if (hasApiError()) {
  <!-- Error page: header visible, no navbar, no content -->
  <main>
    <div class="not-provisioned-page">
      <div class="not-provisioned-card">
        <mat-icon class="error-icon">person_off</mat-icon>
        <h1>Account Not Provisioned</h1>
        <p>
          Your Columbia UNI has been authenticated, but your account has not been
          registered in the CAPS system.
        </p>
        <p>
          Please contact an <strong>Academic Appointment Administrator</strong> to
          request access to CAPS.
        </p>
      </div>
    </div>
  </main>
} @else {
  <app-navbar></app-navbar>
  <main>
    <ng-container>
      @if (showLoginPage()) {
        <!-- Login Content within main layout -->
        <div class="login-content">
          <div class="login-card">
            <div class="login-header">
              <h1>CAPS - Academic Academic Personnel System</h1>
              <p>Please sign in with your Columbia University credentials to access the system.</p>
            </div>

            <div class="login-actions">
              <button
                mat-raised-button
                color="primary"
                (click)="login()"
                class="login-button"
                matTooltip="Sign in using your Columbia University credentials">
                Sign In with Columbia ID
              </button>
            </div>
          </div>
        </div>
      } @else if (showDashboardButton()) {
        <!-- Go to Dashboard Content -->
        <div class="login-content">
          <div class="login-card">
            <div class="login-header">
              <h1>Welcome to CAPS</h1>
              <p>You are successfully authenticated. Click below to access your dashboard.</p>
            </div>

            <div class="login-actions">
              <button
                mat-raised-button
                color="primary"
                (click)="goToDashboard()"
                class="login-button"
                matTooltip="Access your personalized dashboard">
                <mat-icon>dashboard</mat-icon>
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      } @else {
        <!-- Authenticated app content. The breadcrumb sits here rather than in
             each page: it renders nothing unless the current route declares a
             place in the trail. -->
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
      }
    </ng-container>
  </main>
}
